import React from "react";
import { Button, InputNumber, Table } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

/**
 * RewardTierField — bảng MỐC thưởng theo giá trị đơn (field type `tier_table`).
 * value = [{ minValue, amount }]. Một dòng duy nhất = thưởng phẳng.
 *
 * BE sắp lại giảm dần và validate (mốc cao phải thưởng ≥ mốc thấp, không trùng mốc)
 * nên ở đây chỉ lo nhập liệu — không nhân bản luật ra FE.
 */
function RewardTierField({ field, value, onChange }) {
    const rows = Array.isArray(value) && value.length ? value : field.default || [];

    const update = (idx, key, val) => {
        const next = rows.map((r, i) => (i === idx ? { ...r, [key]: val } : r));
        onChange(field.key, next);
    };
    const addRow = () => {
        const last = rows[rows.length - 1] || { minValue: 100000, amount: 10000 };
        onChange(field.key, [...rows, { minValue: Number(last.minValue || 0) * 2, amount: Number(last.amount || 0) + 10000 }]);
    };
    const removeRow = (idx) => onChange(field.key, rows.filter((_, i) => i !== idx));

    return (
        <div className="w-full">
            <Table
                size="small"
                pagination={false}
                rowKey={(_, i) => i}
                dataSource={rows.map((r, i) => ({ ...r, _i: i }))}
                columns={[
                    {
                        title: "Đơn từ (đ)", width: 190,
                        render: (_, r) => (
                            <InputNumber
                                min={0} step={50000} style={{ width: 160 }}
                                value={r.minValue}
                                formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                parser={(v) => (v || "").replace(/\./g, "")}
                                onChange={(v) => update(r._i, "minValue", v)}
                            />
                        ),
                    },
                    {
                        title: "Thưởng (đ)", width: 190,
                        render: (_, r) => (
                            <InputNumber
                                min={1000} step={5000} style={{ width: 160 }}
                                value={r.amount}
                                formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                parser={(v) => (v || "").replace(/\./g, "")}
                                onChange={(v) => update(r._i, "amount", v)}
                            />
                        ),
                    },
                    {
                        title: "", width: 50,
                        render: (_, r) =>
                            rows.length > 1 ? (
                                <Button type="text" danger icon={<DeleteOutlined />} onClick={() => removeRow(r._i)} />
                            ) : null,
                    },
                ]}
            />
            <Button className="mt-2" size="small" icon={<PlusOutlined />} onClick={addRow}>
                Thêm mốc
            </Button>
            {field.hint && <p className="text-xs text-content-3 mt-1 max-w-2xl">{field.hint}</p>}
        </div>
    );
}

export default RewardTierField;
